import { post } from '@/axios'

export interface IUserBanAppealRequest {
  /**
   * 理由
   */
  appeal_reason: string
  /**
   * 邮箱
   */
  email: string
  /**
   * 封禁ID
   */
  id: string
  /**
   * 用户ID
   */
  user_id: string
}

export const userBanAppeal = async (data: IUserBanAppealRequest) => {
  const response = await post('/user/banAppeal', data)

  return response
}
